import { useQuery } from '@apollo/client/react';

import { GetCsClinicCategoriesDocument } from '~/graphql/generated/graphql';

export const useFetchCsCategories = () => {
  const { loading, data } = useQuery(GetCsClinicCategoriesDocument);

  return {
    loading,
    csCategories: data?.csClinicCategories || [],
  };
};
